// [SPRINT K P1] Services config — 20 catégories prestataires.
// Slug snake_case stable (utilisé en route /services/:category et endpoint API).

export const SERVICE_CATEGORIES = [
  { slug: "electricien",                    label: "Électricien",                   icon: "⚡" },
  { slug: "plombier",                       label: "Plombier",                      icon: "🔧" },
  { slug: "mecanicien",                     label: "Mécanicien",                    icon: "🛠️" },
  { slug: "menuisier",                      label: "Menuisier",                     icon: "🪵" },
  { slug: "reparateur_telephones",          label: "Réparateur téléphones",         icon: "📱" },
  { slug: "coiffeuse_tresseuse",            label: "Coiffeuse / Tresseuse",         icon: "💇" },
  { slug: "couturier_tailleur",             label: "Couturier / Tailleur",          icon: "🧵" },
  { slug: "photographe_videaste",           label: "Photographe / Vidéaste",        icon: "📸" },
  { slug: "traiteur_cuisinier_evenementiel", label: "Traiteur / Cuisinier",         icon: "🍽️" },
  { slug: "demenageur",                     label: "Déménageur",                    icon: "📦" },
  { slug: "chauffeur_prive",                label: "Chauffeur privé",               icon: "🚗" },
  { slug: "climatisation_frigoriste",       label: "Climatisation / Frigoriste",    icon: "❄️" },
  { slug: "femme_de_menage",                label: "Femme de ménage",               icon: "🧹" },
  { slug: "peintre_batiment",               label: "Peintre en bâtiment",           icon: "🎨" },
  { slug: "carreleur",                      label: "Carreleur",                     icon: "🧱" },
  { slug: "vitrier_serrurier",              label: "Vitrier / Serrurier",           icon: "🔑" },
  { slug: "jardinier",                      label: "Jardinier",                     icon: "🌿" },
  { slug: "prof_particulier",               label: "Prof particulier",              icon: "📚" },
  { slug: "esthéticienne_domicile",         label: "Esthéticienne à domicile",      icon: "💅" },
  { slug: "dj_sonorisation_evenements",     label: "DJ / Sonorisation",             icon: "🎧" },
];

export function getServiceCategoryBySlug(slug) {
  if (!slug) return null;
  return SERVICE_CATEGORIES.find((c) => c.slug === slug) || null;
}

export default SERVICE_CATEGORIES;
